var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 9,
    viewBox: "0 0 8 9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Polygon_125",
    "data-name": "Polygon 125",
    d: "M3.628,1.549a1,1,0,0,1,1.743,0l2.79,4.96A1,1,0,0,1,7.29,8H1.71A1,1,0,0,1,.838,6.51Z",
    transform: "translate(0 9) rotate(-90)",
    fill: "#16161a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarArrow);
export default __webpack_public_path__ + "static/media/calendar-arrow.70bb3834beb340b7581508f60cc2a3dd.svg";
export { ForwardRef as ReactComponent };